<template>
    <main>
        <div class="bui-container">
            <div class="bui-select" ref="select" @click="showOptionFun" :class="{on: showOption}" :style="[width && height ? {'width': width, 'height': height} : {}]" ga-data="1807001">
                <span :class="{'on': holderText != placeholder}">{{holderText}}</span>
                <img v-if="!showOption" src="../../images/arrow_down_circle.svg" />
                <img v-else src="../../images/arrow_up_circle.svg" />
            </div>
            <transition name="fade">
                <div class="options" ref="option" v-show="showOption" :style="[width ? {'width': width} : {}]">
                    <p v-for="(item, index) in options" :key="index" @click.stop="select(item.id, item.val)" :class="{on: item.val == holderText}">{{item.val}}<span></span></p>
                </div>
            </transition>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'selectBox',
        props: {
            'id': {
                type: String,
                default: ''
            },
            'options': {
                required: true,
                type: Array
            },
            'placeholder': {
                required: true,
                type: String
            },
            'width': {
                required: false,
                type: String
            },
            'height': {
                required: false,
                type: String
            },
        },
        data() {
            return {
                showOption: false,
                holderText: this.placeholder || "",
            };
        },
        watch: {
            options(val) {
                if(val) {
                    const temp = this.options.filter((item) => Number(this.id) === item.id);
                    if (temp && temp.length) {
                       this.holderText = temp[0].val;
                    }
                }
            }
        },
        methods: {
            select(id, val) {
                this.showOption = false; // 隐藏option弹窗
                this.holderText = val; // 为select框赋值
                this.$emit("selectOption", id);
            },
            showOptionFun() {
                this.showOption = true;
            },
            attachClick() {
                var vm = this;
                document.body.addEventListener("click", vm.handleClose);
            },
            removeClick() {
                var vm = this;
                document.body.removeEventListener("click", vm.handleClose);
            },
            handleClose(e) {
                if (e.target != this.$refs['option'] && e.target != this.$refs['select'] && e.target.parentElement != this.$refs['select']) {
                    this.showOption = false
                }
            }
        },
        created() {},
        mounted() {
            this.attachClick();
        },
        beforeDestory() {
            this.removeClick();
        }
    };
</script>

<style lang="scss" scoped>
    main {
        width: auto;
    }
    .bui-container {
        position: relative;
        user-select: none;
    }
    .bui-select {
        position: relative;
        width: 262px;
        height: 40px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 2px solid #CCCCCC;
        border-radius: 100px;
        cursor: pointer;
        span {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            color: #CCCCCC;
            letter-spacing: 0;
            &.on {
                color: #444444;
            }
        }
        img {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            width: 12px;
        }
        &.on,
        &:hover {
            border-color: #50BBE5;
        }
    }
    .options {
        position: absolute;
        top: 40px;
        margin-top: 10px;
        padding: 0 20px;
        box-sizing: border-box;
        width: 262px;
        background: #FFFFFF;
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.20);
        border-radius: 20px;
        cursor: pointer;
        z-index: 1;
        p {
            display: flex;
            align-items: center;
            position: relative;
            height: 50px;
            margin: 0 auto;
            // line-height: 50px;
            font-size: 14px;
            color: #444444;
            letter-spacing: 0;
            &:hover,
            &.on {
                color: #50BBE5;
                span {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 8px;
                    height: 30px;
                    background-color: #7ACEF5;
                    border-radius: 4px;
                }
            }
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter,
    .fade-leave-to
    /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
